<template>
  <div>
    <label for="password">
      Password
    </label>
    <v-text-field
      id="password"
      v-model="password"
      :error-messages="passwordErrors"
      required
      type="password"
      variant="outlined"
      autofocus
      @change="validatePassword"
      @keydown.enter="submit"
    />
    <label for="repeatPassword">
      Repeat Password
    </label>
    <v-text-field
      id="repeatPassword"
      v-model="repeatPassword"
      :error-messages="repeatPasswordErrors"
      required
      type="password"
      variant="outlined"
      @change="validateRepeatPassword"
      @keydown.enter="submit"
    />
    <v-btn
      class="action mt-1 animate-btn"
      variant="outlined"
      :disabled="submitLock"
      @click="submit"
    >
      Reset Password
    </v-btn>
    <router-link
      to="/login"
      class="text-decoration-none d-block mt-6"
    >
      <v-icon>mdi-arrow-left</v-icon> Back to login
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  props: {
    errorMessage: {
      type: String,
      default: null
    },
    successMessage: {
      type: String,
      default: null
    }
  },
  emits: ['update:errorMessage', 'update:successMessage'],
  data () {
    return {
      password: '',
      passwordErrors: [],
      repeatPassword: '',
      repeatPasswordErrors: [],
      submitLock: false,
    }
  },
  methods: {
    validatePassword () {
      this.passwordErrors = []
      this.repeatPasswordErrors = []
      if (!this.password) {
        this.passwordErrors.push('Password is required')
      } else if (this.password.length < 6) {
        this.passwordErrors.push('Password must be at least 6 characters')
      }
      return this.passwordErrors.length === 0
    },
    validateRepeatPassword () {
      this.repeatPasswordErrors = []
      if (!this.repeatPassword) {
        this.repeatPasswordErrors.push('Repeat password is required')
      } else if (this.repeatPassword !== this.password) {
        this.repeatPasswordErrors.push('Passwords do not match')
      }
      return this.repeatPasswordErrors.length === 0
    },
    setError (error) {
      this.$emit('update:errorMessage', error)
    },
    async submit () {
      if (this.submitLock) {
        return
      }
      this.setError(null)
      if (!this.validatePassword() || !this.validateRepeatPassword()) {
        return
      }
      this.submitLock = true
      // All validations passed, so send invite request to token service
      try {
        await this.$auth.resetPassword(this.$route.query.id, this.$route.query.token, this.password)
        this.$router.push({ path: '/login' }).catch()
        this.$emit('update:successMessage', 'Password reset successfully')
      } catch (error) {
        this.setError('Something went wrong')
        console.error(error)
      }
      this.submitLock = false
    }
  }
}
</script>
